import { getCompanyMe } from "@/services/auth/companyAuthService";

export async function companyGuard(to, from, next) {
  try {
    const { data } = await getCompanyMe();

    if (data?.company) {
      next();
      return;
    }

    next({ name: "login-comp" });
  } catch {
    next({ name: "login-comp" });
  }
}
